import React, { Component } from 'react';


export class UserCard extends Component{

    render(){
        const avatarStyle = {
          width: '100%',
          height: '100%',
          backgroundImage: 'url(' + this.props.avatar + ')',
          backgroundSize: 'cover',
          borderRadius: '50%',
          backgroundColor: '#fff'
        };
        return (
            <div className="card card-user">
                <div className="image">
                    <img src={this.props.bgImage} alt="..."/>
                </div>
                <div className="content">
                    <div className="author">
                        <div >
                          <div className="photo">
                            <div className="avatar border-gray" style={avatarStyle}></div>

                          </div>
                            <h4 className="title">
                                {this.props.name}
                                <br />
                                <small>{this.props.userName}</small>
                            </h4>
                        </div>
                    </div>
                    <p className="description text-center">
                        {this.props.description}
                    </p>
                </div>
                <hr />
                <div className="text-center">
                    {this.props.socials}
                </div>
            </div>
        );
    }
}

export default UserCard;



// WEBPACK FOOTER //
// ./src/components/Card/UserCard.jsx